module.exports = __webpack_public_path__ + "static/media/registerLockGuide3.6be3f2fd.png";